import { useUser } from "@dashboard/auth";
import { hasPermissions } from "@dashboard/components/RequirePermissions";
import { PermissionEnum } from "@dashboard/graphql";
import { customerListUrl } from "@dashboard/customers/urls";
import { Button, Tooltip } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { PrimaryActionProps } from "./type";
import { WelcomePageFakeDisabledButton } from "./WelcomePageFakeDisabledButton";

export const WelcomePageCustomersButton = ({ onClick }: PrimaryActionProps) => {
  const { user } = useUser();
  const userPermissions = user?.userPermissions || [];
  const hasPermissionToManageCustomers = hasPermissions(userPermissions, [
    PermissionEnum.MANAGE_USERS,
  ]);

  if (!hasPermissionToManageCustomers) {
    return (
      <Tooltip>
        <Tooltip.Trigger>
          <WelcomePageFakeDisabledButton>
            <FormattedMessage
              defaultMessage="Go to all customers"
              id="customers.button"
              description="btn label"
            />
          </WelcomePageFakeDisabledButton>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Tooltip.Arrow />
          <FormattedMessage
            defaultMessage="You don't have permission to manage customers"
            id="customers.permission"
          />
        </Tooltip.Content>
      </Tooltip>
    );
  }

  return (
    <Link to={customerListUrl()} onClick={onClick}>
      <Button variant="primary">
        <FormattedMessage defaultMessage="Go to all customers" id="customers.button" description="btn label" />
      </Button>
    </Link>
  );
};